<template>
  <div class="asc-report-data-item">
    <div v-if="isTitle">
      <asc-report-title :value="report.text"></asc-report-title>
    </div>
    <div v-if="isSubtitle">
      <asc-subtitle :value="report.text"></asc-subtitle>
    </div>
    <div v-if="isSubheader">
      <asc-label size="lg" :value="report.text"></asc-label>
    </div>
    <div v-if="isMultipleSubheaders">
      <asc-report-multiple-subheaders
        :value="report.text"
      ></asc-report-multiple-subheaders>
    </div>
    <div v-if="isNote">
      <asc-report-note :value="report.text"></asc-report-note>
    </div>
    <div v-if="isSingleValue">
      <asc-report-single-value :report="report"></asc-report-single-value>
    </div>
    <div v-if="isColumnTable">
      <asc-report-column-table
        :report="report"
        :on-report-menu-click="onReportMenuClick"
      ></asc-report-column-table>
    </div>
    <div v-if="isDate">
      <asc-report-date :value="report.text"></asc-report-date>
    </div>
  </div>
</template>

<script>
import { AscReportMenuClickMixin } from '@/components/mixins'
import AscSubtitle from '@/components/atoms/AscSubtitle'
import AscLabel from '@/components/atoms/AscLabel'
import AscReportTitle from './AscReportTitle'
import AscReportMultipleSubheaders from './AscReportMultipleSubheaders'
import AscReportNote from './AscReportNote'
import AscReportSingleValue from './AscReportSingleValue'
import AscReportColumnTable from './AscReportColumnTable'
import AscReportDate from './AscReportDate'
import * as constants from '@/utilities/appConsts'

export default {
  name: 'AscReportDataItem',

  components: {
    AscReportTitle,
    AscSubtitle,
    AscLabel,
    AscReportMultipleSubheaders,
    AscReportNote,
    AscReportSingleValue,
    AscReportColumnTable,
    AscReportDate,
  },

  mixins: [AscReportMenuClickMixin],

  props: {
    report: {
      type: Object,
      default: null,
    },
  },

  computed: {
    isTitle() {
      return this.report
        ? this.report.type === constants.REPORT_DATA_VALUES.title
        : null
    },
    isSubtitle() {
      return this.report
        ? this.report.type === constants.REPORT_DATA_VALUES.subtitle
        : null
    },
    isSubheader() {
      return this.report
        ? this.report.type === constants.REPORT_DATA_VALUES.subheader
        : null
    },
    isMultipleSubheaders() {
      return this.report
        ? this.report.type === constants.REPORT_DATA_VALUES.multipleSubheaders
        : null
    },
    isNote() {
      return this.report
        ? this.report.type === constants.REPORT_DATA_VALUES.note
        : null
    },
    isSingleValue() {
      return this.report
        ? this.report.type === constants.REPORT_DATA_VALUES.singleValue
        : null
    },
    isColumnTable() {
      return this.report
        ? this.report.type === constants.REPORT_DATA_VALUES.columnTable
        : null
    },
    isDate() {
      return this.report
        ? this.report.type === constants.REPORT_DATA_VALUES.date
        : null
    },
  },
}
</script>

<style lang="scss">
.asc-report-data-item {
  margin-bottom: 8px;
}
</style>
